let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2bmrJ"), load("8NLae"), load("c6MKV"), load("dnwTC")]).then(() => parcelRequire('3Jp28'));